import { AppStateType } from '../reducers'
import { createSelector } from 'reselect'
import { IMediaTypeGroup } from '../types/mediaTypeGroup'
import { IMediaTypeGroups } from '../types/mediaTypeGroups'

export const selectMediaTypeGroup = createSelector(
  [(state: AppStateType) => state.mediaTypeGroup],
  (mediaTypeGroup: IMediaTypeGroup) => mediaTypeGroup
)

export const selectMediaTypeGroups = createSelector(
  [(state: AppStateType) => state.mediaTypeGroups],
  (mediaTypeGroups: IMediaTypeGroups) =>
    mediaTypeGroups && mediaTypeGroups.list && mediaTypeGroups
)

export const selectMediaTypeGroupsAsOptions = createSelector(
  [(state: AppStateType) => state.mediaTypeGroups],
  (mediaTypeGroups: IMediaTypeGroups) =>
    mediaTypeGroups &&
    mediaTypeGroups.list && {
      list: mediaTypeGroups.list.map(({ title, id }) => ({
        value: id,
        label: title,
      })),
    }
)
